import '../App.css';
import { Header, Button, Container, Segment, Input, Form, TextArea, Message, MessageHeader } from 'semantic-ui-react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { db } from "../utils/firebase";
import { set, ref, get } from "firebase/database";
import { useAuth } from "../App";
import LoginDialog from '../components/dialog/LoginDialog';
import { firebaseConfig } from '../utils/firebase'
import RegistrationDialog from '../components/dialog/RegistrationDialog';
import LoadingSpinner from '../components/LoadingSpinner';
import { trackSendingMessageEvent } from '../utils/analytics';
import { BackgroundContainer } from '../components/BackgroundContainer';


function MessageFormPage() {
  const { user } = useAuth();
  const location = useLocation();
  const [alias, setAlias] = useState(null);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState(null);
  const [invalidChannel, setInvalidChannel] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [registrationOpen, setRegistrationOpen] = useState(false);
  const [channel, setChannel] = useState(null);
  const [channels, setChannels] = useState(null);
  const [msgContent, setMsgContent] = useState("");

  useEffect(() => {
    if (user && user.email && user.data.alias) {
      setAlias(user.data.alias);
    }
  }, user);

  useEffect(() => {
    //load channels
    const userRef = ref(db, "channels");
    get(userRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          setChannels(snapshot.val());
        } else {
          console.log("Žiadne dáta");
        }
      })
      .catch((error) => {
        console.error("Chyba pri čítaní dát:", error);
      });
  }, []);

  useEffect(() => {
    const candidate = extractLocation().toUpperCase();
    if (channels) {
      setLoading(false);
      if (channels[candidate]) {
        setChannel(candidate);
      } else {
        setInvalidChannel(true);
      }
    }
  }, [location, channels]);

  const reset = () => {
    setMsgContent("");
  }

  const extractLocation = () => {
    return (location?.pathname?.startsWith("/")) ? location?.pathname?.substring(1) : location?.pathname;
  }

  const isValid = () => {
    return msgContent && msgContent.length > 0
  }

  const onMsgContentChange = (event) => {
    setMsgContent(event.target.value);
  }

  const onNameChange = (event) => {
    setAlias(event.target.value);
  }
  const onSendClick = () => {
    if (!alias) {
      setRegistrationOpen(true);
    } else {
      sendMessage(alias);
    }
  }

  const sendMessage = (actualAlias) => {
    const message = {
      aliasA: channel,
      aliasB: actualAlias,
      content: msgContent,
      time: new Date().getTime()
    }

    const chatIdArray = [message.aliasA, message.aliasB]
    chatIdArray.sort();
    const chatId = chatIdArray[0] + "_" + chatIdArray[1];

    set(ref(db, 'chats/' + chatId + "/" + Date.now()), message).then(res => {

      //updating links
      set(ref(db, `chatLinks/${message.aliasA}/${message.aliasB}`), true)
        .then(() => {
          console.log('Úspešne uložené!');
        })
      set(ref(db, `chatLinks/${message.aliasB}/${message.aliasA}`), true)
        .then(() => {
          console.log('Úspešne uložené!');
        })

      reset();
      setSuccessMessage('Tvoja správa bola úspešne odoslaná!');
      trackSendingMessageEvent();
    }).catch(() => { });


    console.log(JSON.stringify(message));
  }

  if (loading) {
    return <LoadingSpinner />
  }

  return (
    <BackgroundContainer>
      <Container textAlign='center'>
        {loading && <Message warning>
          <MessageHeader>Overujem adresu</MessageHeader>
          Prosím počkaj...
        </Message>}
        {!loading && invalidChannel && <Message color="grey">
          <MessageHeader>Neplatná adresa</MessageHeader>
          Na túto adresu nemôžeš posielať správu...
        </Message>}
        {!loading && !successMessage && !invalidChannel &&
          <Segment>
            <Container className="standardMargin">
              <Header size='medium'>Poslať správu na: {channel}</Header>
            </Container>
            <Container className="standardMargin">
              <Input onChange={onNameChange} disabled label='Tvoj alias' value={alias ? alias : '<žiaden>'} />
            </Container>
            <Container className="standardMargin">
              <Form>
                <TextArea onChange={onMsgContentChange} placeholder='Tvoja správa' value={msgContent} />
              </Form>
            </Container>
            <Button disabled={!isValid()} onClick={onSendClick} color='yellow'>Poslať správu</Button>
          </Segment>
        }
        {
          successMessage && <Message warning>
            <MessageHeader>Správa poslaná</MessageHeader>
            {successMessage}
          </Message>
        }

      </Container>
      <LoginDialog
        intent='sendMessage'
        open={loginOpen}
        onClose={() => setLoginOpen(false)}
        onSuccess={(alias) => {
          sendMessage(alias);
          setRegistrationOpen(false);
        }}
        firebaseConfig={firebaseConfig} // alebo zdieľaný `auth` cez props
      />
      <RegistrationDialog
        intent='sendMessage'
        open={registrationOpen}
        onClose={() => setRegistrationOpen(false)}
        onLoginClick={() => {
          setRegistrationOpen(false);
          setLoginOpen(true);
        }}
        onSuccess={(alias) => {
          sendMessage(alias);
          setRegistrationOpen(false);
        }}
        firebaseConfig={firebaseConfig}
      />
    </BackgroundContainer>
  );
}

export default MessageFormPage;
